<template>
    <div>
        <a-drawer
            :title="$t('reportSetting.importTemplate')"
            placement="right"
            :visible="visible"
            @close="() => (visible = !visible)"
            width="95%"
        >
            <a-row style="padding: 4px">

                <a-row type="flex" justify="start" class="ml4tb">
                    <a-col>
                        <a-row  type="flex" justify="start">
                            <a-col>
                                {{$t('generic.Module')}} :
                            </a-col>
                            <a-col  class="ml4">
                                <a-select show-search optionFilterProp="label" :placeholder="$t('publicLang.PleaseSelect')" style="width: 150px"  size="small" v-model="ModuleVal" @change="moduleCodeAjax">
                                    <a-select-option v-for="item in selectModuleData" :label="item.dispName" :key="item.moduleCode" :value="item.moduleCode" >{{item.dispName}}</a-select-option>
                                </a-select>
                                <p class="infoError" v-if="!ModuleVal">{{ $t('publicLang.pleaseOneOnly')}}</p>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col class="ml4">
                        <a-dropdown :disabled="!leftModeRadioVal">
                            <a-menu slot="overlay" >
                                <a-menu-item key="1">
                                <span class="sbxs" style="font-size: 12px;color: black;position: relative;overflow: hidden;">{{ $t('reportSetting.Upload')}}
                                    <input class="sbxs" style="position: absolute;opacity:0;left: 0;top: 0;" ref="topimportExcelRef"  v-on:change="topFileChange($event)" type="file">
                                </span>
                                </a-menu-item>
                                <a-menu-item key="2" @click="topImportDown" class="sbxs" style="color: black;font-size: 12px;">{{ $t('publicLang.Download') }}</a-menu-item>
                            </a-menu>
                            <a-button type="primary" size="small"> {{ $t('reportSetting.UploadConfig') }}<a-icon type="down" /> </a-button>
                        </a-dropdown>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="start" >
                    <a-col :span="4" class="importCon">
                        <p class="importConTitle">{{ $t('publicLang.Template') }}</p>
                        <a-row type="flex" justify="end" class="mt4 mr4">
                            <a-button type="primary" size="small" @click="goClone" :disabled="ModuleVal ? false:true">{{ $t('reportSetting.Clone') }}</a-button>
                            <a-button type="primary" size="small" class="mllr4" @click="leftAddImport" :disabled="ModuleVal ? false:true">+</a-button>
                            <a-popconfirm
                                :title="$t('generic.AreyoudeleTask')"
                                @confirm="leftDeleteImport"
                                :okText="$t('publicLang.Yes')"
                                :cancelText="$t('publicLang.No')"
                            >
                                <a-button type="primary" size="small" :disabled="ModuleVal ? false:true">-</a-button>
                            </a-popconfirm>
                            <img class="sbxs mllr4" @click="leftAddImport('edit')" src="../../../assets/img/ss-edit.png" width="25" height="25" >
                        </a-row>
                        <a-row class="mt4 ml4 importCheckboxGrop">
                            <a-radio-group v-model="leftModeRadioVal" @change="leftRadioChange">
                                <a-row v-for="item in radioDataLeft" :key="item.uid">
                                    <a-radio :value="item.uid" >
                                        <a-tooltip>
                                            <template slot="title">
                                                {{ item.masterName }}
                                            </template>
                                            {{ item.masterName | radiosValueSubLength}}
                                        </a-tooltip>

                                    </a-radio>
                                </a-row>
                            </a-radio-group>
                        </a-row>
                    </a-col>

                    <a-col :span="20" >
                        <a-row class="importCon ml10">
                            <p class="importConTitle">{{ $t('reportSetting.importConfig') }}</p>
                            <a-row class="padding6">
                                <a-row type="flex" justify="end" class="mb4">
                                    <a-button type="primary" size="small" class="mllr4" @click="addEditImportConfig('add')" :disabled="!leftModeRadioVal">+</a-button>

                                    <a-popconfirm
                                            :title="$t('generic.AreyoudeleTask')"
                                            @confirm="tableDeleteImport('t')"
                                            :okText="$t('publicLang.Yes')"
                                            :cancelText="$t('publicLang.No')"
                                    >
                                        <a-button type="primary" size="small" :disabled="!leftModeRadioVal">-</a-button>
                                    </a-popconfirm>

                                </a-row>
                                <div style="height: 32vh;">
                                    <vxe-table
                                            stripe
                                            highlight-hover-row
                                            border
                                            resizable
                                            show-overflow
                                            height="auto"
                                            ref="ImportConfigRef"
                                            @cell-dblclick="dbcellClickEvent"
                                            size="mini"
                                            :data="importConfigList">
                                        <template v-slot:empty>
                                            <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                                        </template>
                                        <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                                        <vxe-table-column min-width="70" show-header-overflow="ellipsis" show-overflow="ellipsis"  field="fromFieldName" :title="$t('reportSetting.importColumn')"></vxe-table-column>
                                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="toFieldName" :title="$t('reportSetting.Mapping')" min-width="70"></vxe-table-column>
                                        <vxe-table-column min-width="40" show-header-overflow="ellipsis" show-overflow="ellipsis" field="isUniqueKey" :title="$t('reportSetting.Uniquekey')"></vxe-table-column>
                                         <vxe-table-column min-width="40" show-header-overflow="ellipsis" show-overflow="ellipsis"  field="referenceKey" :title="$t('reportSetting.ReferenceKey')"></vxe-table-column>
                                        <vxe-table-column min-width="40" show-header-overflow="ellipsis" show-overflow="ellipsis" field="defaultType" :title="$t('reportSetting.DefaultType')"></vxe-table-column>
                                        <vxe-table-column min-width="45" show-header-overflow="ellipsis" show-overflow="ellipsis" field="defaultVal" :title="$t('reportSetting.DefaultValue')"></vxe-table-column>
                                        <vxe-table-column min-width="40" show-header-overflow="ellipsis" show-overflow="ellipsis" field="dataType" :title="$t('reportSetting.DataType')"></vxe-table-column>
                                        <vxe-table-column min-width="40" show-header-overflow="ellipsis" show-overflow="ellipsis" field="dataLength" :title="$t('reportSetting.Datalength')"></vxe-table-column>
                                        <vxe-table-column min-width="40" show-header-overflow="ellipsis" show-overflow="ellipsis" field="startPosition" :title="$t('reportSetting.StartPosition')"></vxe-table-column>
                                        <vxe-table-column min-width="40" show-header-overflow="ellipsis" show-overflow="ellipsis" field="endPosition" :title="$t('reportSetting.EndPosition')"></vxe-table-column>
                                        <vxe-table-column min-width="40" show-header-overflow="ellipsis" show-overflow="ellipsis" field="fieldLengthDigit" :title="$t('reportSetting.DecimalalPlace')"></vxe-table-column>
                                        <!-- <vxe-table-column min-width="40" show-header-overflow="ellipsis" show-overflow="ellipsis" field="dateTimeFormat" :title="$t('reportSetting.DateTimeFormat')"></vxe-table-column> -->
                                        <vxe-table-column min-width="30" show-header-overflow="ellipsis" show-overflow="ellipsis" field="isMandatory" :title="$t('reportSetting.Mandatory')"></vxe-table-column>

                                        
                                    </vxe-table>
                                </div>
                            </a-row>
                        </a-row>

                        <a-row class="importCon ml10 mt">
                            <p class="importConTitle">{{ $t('generic.defaultValue') }}</p>
                            <a-row class="padding6">
                                <a-row type="flex" justify="end" class="mb4">
                                    <a-button type="primary" size="small" class="mllr4" @click="defalutValAddEdit" :disabled="!leftModeRadioVal">+</a-button>
                                    <a-button type="primary" size="small" @click="tableDeleteImport('b')" :disabled="!leftModeRadioVal">-</a-button>
                                </a-row>

                                <div style="height: 32vh;">
                                    <vxe-table
                                            stripe
                                            highlight-hover-row
                                            border
                                            resizable
                                            show-overflowauto
                                            height="auto"
                                            size="mini"
                                            ref="defaultValueTableRef"
                                            @cell-dblclick="defaultValuedbcellClick"
                                            :edit-config="{trigger: 'click', mode: 'row',key: 'uid'}"
                                            :data="defaultValueList">
                                        <template v-slot:empty>
                                            <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                                        </template>
                                        <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="toFieldName" :title="$t('reportSetting.Mapping')">
                                            <template v-slot="{ row }">
                                                <a-tooltip placement="bottomLeft">
                                                    <template slot="title">
                                                        <span>{{row.toFieldName}}</span>
                                                    </template>
                                                    <span>{{row.toFieldName}}</span>
                                                </a-tooltip>
                                            </template>
                                        </vxe-table-column>




                      <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="defaultType" :title="$t('reportSetting.ReferenceKey')">
                                            <template v-slot="{ row }">
                                                <a-tooltip placement="bottomLeft">
                                                    <template slot="title">
                                                        <span>{{row.referenceKey}}</span>
                                                    </template>
                                                    <span>{{row.referenceKey}}</span>
                                                </a-tooltip>
                                            </template>
                                        </vxe-table-column>





                                          <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="defaultType" :title="$t('reportSetting.RangeValue')">
                                            <template v-slot="{ row }">
                                                <a-tooltip placement="bottomLeft">
                                                    <template slot="title">
                                                        <span>{{row.rangeValue}}</span>
                                                    </template>
                                                    <span>{{row.rangeValue}}</span>
                                                </a-tooltip>
                                            </template>
                                        </vxe-table-column>




                                        
                                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="defaultType" :title="$t('reportSetting.DefaultType')">
                                            <template v-slot="{ row }">
                                                <a-tooltip placement="bottomLeft">
                                                    <template slot="title">
                                                        <span>{{row.defaultType}}</span>
                                                    </template>
                                                    <span>{{row.defaultType}}</span>
                                                </a-tooltip>
                                            </template>
                                        </vxe-table-column>
                                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="defaultVal" :title="$t('generic.defaultValue')">
                                            <template v-slot="{ row }">
                                                <a-tooltip placement="bottomLeft">
                                                    <template slot="title">
                                                        <span>{{row.defaultVal}}</span>
                                                    </template>
                                                    <span>{{row.defaultVal}}</span>
                                                </a-tooltip>
                                            </template>
                                        </vxe-table-column>
                                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="combField" :title="$t('reportSetting.CombineFields')">
                                            <template v-slot="{ row }">
                                                <a-tooltip placement="bottomLeft">
                                                    <template slot="title">
                                                        <span>{{row.combField}}</span>
                                                    </template>
                                                    <span>{{row.combField}}</span>
                                                </a-tooltip>
                                            </template>
                                        </vxe-table-column>
                                    </vxe-table>
                                </div>
                            </a-row>
                        </a-row>
                    </a-col>
                </a-row>
            </a-row>
        </a-drawer>
<!--add-->
        <a-modal
            :maskClosable="false"
            :title="leftEditTemplateVal.uid == null ? $t('manual.New')+ ' '+ $t('publicLang.Template') :$t('generic.Edit')+ ' '+$t('publicLang.Template')"
            :visible="LeftAddVis"
             width="50%"
             @cancel="() => (LeftAddVis = !LeftAddVis)">
            <template slot="footer">
                <a-row type="flex" justify="end" >
                    <a-col class="mr4">
                        <div class="file sbxs" :style="{background: !creatUid ? '#efefef': '#1890ff'}">
                            {{ $t('reportSetting.Upload')}}
                            <input  ref="importExcelRef"  v-on:change="fileChange($event)" type="file"  :disabled="!creatUid">
                        </div>
                    </a-col>
                    <a-col>
                        <a-button type="primary" size="small" @click="CreateTemplate">{{ leftEditTemplateVal.uid == null ? $t('login.Create') : $t('publicLang.Save')}}</a-button>
                    </a-col>
                </a-row>

            </template>
            <a-form :form="addform" >
                <a-form-item :label="$t('reportSetting.FileType')" v-bind="formItemLayout">
                    <a-select
                         show-search
                         optionFilterProp="label"
                          :placeholder="$t('publicLang.PleaseSelect')"
                          style="width: 100%"
                          size="small" 
                           v-decorator="[
                          'fileType',
                          {
                              initialValue: leftEditTemplateVal.fileType == null ? 'Excel' : leftEditTemplateVal.fileType,
                              rules: [{ required: true, message: $t('publicLang.Required')}] }
                        ]"
                          >
                        <a-select-option label="Excel" value="Excel">Excel</a-select-option>
                        <a-select-option label="Text Fixed Width (.txt 文件)" value="TXT">Text Fixed Width (.txt 文件)</a-select-option>
                        <a-select-option label="CSV (Comma delimited)" value="CSV">CSV (Comma delimited)</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item :label="$t('reportSetting.Delimilter')" v-bind="formItemLayout" v-if="false">
                    <a-input
                        style="width: 100%"
                        :placeholder="$t('publicLang.PleaseEnter')"
                        size="small"
                        v-decorator="[
                          'deliimiter',
                           { initialValue: leftEditTemplateVal.deliimiter}
                        ]"/>
                </a-form-item>
                <a-form-item :label="$t('generic.TemplateName')" v-bind="formItemLayout">
                    <a-input
                        size="small"
                        style="width: 100%"
                        :placeholder="$t('publicLang.PleaseEnter')"
                         v-decorator="[
                          'templateName',
                          {
                              initialValue: leftEditTemplateVal.masterName,
                              rules: [{ required: true, message: $t('publicLang.Required')}] }
                        ]"/>
                </a-form-item>

                <a-form-item :label="$t('reportSetting.OperationRule')" v-bind="formItemLayout">
                    <a-select
                        show-search
                         optionFilterProp="label"
                        :placeholder="$t('publicLang.PleaseSelect')"
                        style="width: 100%"
                        size="small"
                        v-decorator="[
                          'opraPule',
                          {
                              initialValue: leftEditTemplateVal.opraPule,
                              rules: [{ required: true, message: $t('publicLang.Required')}] }
                        ]"
                     >
                        <!--== null ? 'O': leftEditTemplateVal.opraPule-->
                        <a-select-option v-for="item in ImportRuleSelectData" :label="item.ruleName" :value="item.ruleCode" :key="item.ruleCode">{{item.ruleName}}</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item :label="$t('reportSetting.withHeader')" v-bind="formItemLayout">
                    <a-select
                             show-search
                            :placeholder="$t('publicLang.PleaseSelect')"                           
                            style="width: 100%"
                            size="small"
                            v-decorator="[
                          'withHdr',
                          {
                              initialValue: leftEditTemplateVal.withHdr == null ? 'true' : leftEditTemplateVal.withHdr,
                              rules: [{ required: true, message: $t('publicLang.Required')}] }
                        ]"
                    >
                        <a-select-option value="true">true</a-select-option>
                        <a-select-option value="false">false</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item :label="$t('reportSetting.excelStartRow')" v-bind="formItemLayout">
                    <a-input-number style="width: 100%;" size="small"  v-decorator="['startRow', { initialValue: leftEditTemplateVal.startRow == null ? 1 : leftEditTemplateVal.startRow }]" :min="0" />
                </a-form-item>


                <!-- <a-form-item label="Date Time Format" v-bind="formItemLayout">
                    <a-input style="width: 100%;" size="small"  v-decorator="['dateFormat', { initialValue: leftEditTemplateVal.dateFormat == null ? 'yyyy/MM/dd' : leftEditTemplateVal.dateFormat }]"  />
                </a-form-item> -->
            </a-form>
        </a-modal>
<!--clone-->
        <a-modal
                :maskClosable="false"
                :title="$t('reportSetting.CloneTemplate')"
                :visible="CloneTemplate.CloneTemplateVis"
                width="50%"
                @cancel="() => (CloneTemplate.CloneTemplateVis = !CloneTemplate.CloneTemplateVis)">
            <template slot="footer">
                  <a-button type="primary" size="small" @click="createClone">{{ $t('login.Create') }}</a-button>
            </template>
            <a-form :form="CloneTemplate.cloneform" >
                <a-form-item :label="$t('publicLang.Project')" v-bind="formItemLayout">
                    <a-select allowClear show-search style="width: 100%" size="small" :placeholder="$t('publicLang.PleaseSelect')" @change="ProjectChange"  v-decorator="['projectCode', { rules: [{ required: true, message: $t('publicLang.Required') }] }]">
                        <a-select-option v-for="item in CloneTemplate.projectSelectData" :value="item.projectCode" :key="item.projectCode">{{ item.projectName }}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item :label="$t('publicLang.ProjectTemplate')" v-bind="formItemLayout">
                    <a-select
                            show-search
                             optionFilterProp="label"
                            allowClear
                            :placeholder="$t('publicLang.PleaseSelect')"
                            style="width: 100%"
                            v-decorator="['geMasterUid',{ rules: [{ required: true, message: $t('publicLang.Required') }] }]"
                            size="small">
                        <a-select-option v-for="item in  CloneTemplate.rojectTemplateData" :key="item.uid" :value="item.uid" :label="item.masterName">{{item.masterName}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item :label="$t('publicLang.NewTemplateName')" v-bind="formItemLayout">
                    <a-input
                        size="small"
                        style="width: 100%"
                        :placeholder="$t('publicLang.PleaseEnter')"
                        v-decorator="[
                          'templateName',
                          { rules: [{ required: true, message: $t('publicLang.Required') }] }
                        ]"/>
                </a-form-item>

                <a-form-item label="Operation Rule" v-bind="formItemLayout">
                    <a-select
                        show-search
                         optionFilterProp="label"
                        :placeholder="$t('publicLang.PleaseSelect')"
                        style="width: 100%"
                        size="small"
                        v-decorator="[
                          'opraPule',
                          {rules: [{ required: true, message: $t('publicLang.Required')}] }]">
                        <a-select-option label="Overwrite" value="O">Overwrite</a-select-option>
                        <a-select-option label="Delete and new" value="C">Delete and new</a-select-option>
                        <a-select-option  label="Alert only" value="A">Alert only</a-select-option>
                        <a-select-option label="Update"  value="U">Update</a-select-option>
                    </a-select>
                </a-form-item>
            </a-form>
        </a-modal>
        <!--Import Config 添加 edit -->
        <a-modal
            :maskClosable="false"
            :title="$t('reportSetting.importConfig')"
            :visible="importConfig.importConfigAddEditVis"
            width="50%"
            @cancel="() => (importConfig.importConfigAddEditVis = !importConfig.importConfigAddEditVis)">
            <template slot="footer">
                <a-button type="primary" size="small" @click="ImportConfigSave">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <a-modal
                    :maskClosable="false"
                    :title="$t('reportSetting.TableColumn')"
                    :visible="importConfig.MappingSearchVis"
                    width="50%"
                    @cancel="() => (importConfig.MappingSearchVis = !importConfig.MappingSearchVis)">
                <template slot="footer">
                    <a-button type="primary" size="small" @click="saveMappingVal">Save</a-button>
                </template>
                <a-tree-select
                        multiple
                        v-model="importConfig.mappingSearchValue"
                        tree-data-simple-mode
                        @change="treedataChange"
                        style="width: 100%"
                        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                        :tree-data="importConfig.treeData"
                        placeholder="Please select"
                        :load-data="onLoadData"
                />
            </a-modal>
            <a-form :form="importConfig.importConfigform" >
                <a-form-item :label="$t('reportSetting.importColumn')" v-bind="formItemLayout">
                    <a-select
                            @search="handleSearch($event)"
                            show-search
                            allowClear
                            style="width: 100%"
                            size="small"
                            :placeholder="$t('publicLang.PleaseSelect')"
                            v-decorator="['fromFieldName',{ initialValue: importConfig.editVal.fromFieldName}]">
                        <a-select-option v-for="item in importConfig.selectData.importColumn" :value="item" :key="item">{{item}}</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="Column Filter" v-bind="formItemLayout">
                    <a-select
                            allowClear
                            style="width: 100%"
                            size="small"
                            :placeholder="$t('publicLang.PleaseSelect')"
                            @change="ColumnFilterChange"
                            v-decorator="['filterType',{ initialValue: importConfig.editVal.filterType}]">
                        <a-select-option value="ONE2MANY">One to Many</a-select-option>
                        <a-select-option value="DEPEND">Depends On</a-select-option>
                    </a-select>
                </a-form-item>


                <a-form-item :label="$t('reportSetting.Mapping')" v-bind="formItemLayout">
                    <div class="relative">
                        <a-input
                            size="small"
                            style="width: 100%"
                            :placeholder="$t('publicLang.PleaseEnter')"
                            disabled
                            v-decorator="[
                              'toFieldName',
                              { initialValue: importConfig.editVal.toFieldName}
                            ]"/>
                        <a-icon type="search" class="searIputIcon sbxs" @click="mappSearch('import')"/>
                    </div>
                </a-form-item>

                <a-form-item v-if="isColumnFilter" label="Default Mapping" v-bind="formItemLayout">
                    <div class="relative">
                        <a-input
                                size="small"
                                style="width: 100%"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                disabled
                                v-decorator="[
                              'defaultMapping',
                              { initialValue: importConfig.editVal.defaultMapping}
                            ]"/>
                        <a-icon type="search" class="searIputIcon sbxs" @click="mappSearch('defaultMapping')"/>
                    </div>
                </a-form-item>
                <a-form-item v-if="isColumnFilter" label="DefaultValue" v-bind="formItemLayout">
                    <a-input
                        size="small"
                        style="width: 100%"
                        :placeholder="$t('publicLang.PleaseEnter')"
                        v-decorator="[
                          'defaultValue',
                          {
                           initialValue: importConfig.editVal.defaultValue,
                           rules: [{max:30}]
                          }
                        ]"/>
                </a-form-item>



                <a-form-item :label="$t('reportSetting.Uniquekey')" v-bind="formItemLayout">
                    <a-switch @change="uniqukeyChange" v-decorator="['isUniqueKey',  { initialValue: importConfig.editVal.isUniqueKey == 'Y' ? true: false,  valuePropName: 'checked',}]"/>
                </a-form-item>
                <a-form-item :label="$t('reportSetting.Mandatory')" v-bind="formItemLayout">
                    <a-switch v-decorator="['isMandatory',  { initialValue: importConfig.editVal.isMandatory == 'Y' ? true: false,  valuePropName: 'checked',}]"/>
                </a-form-item>
                <a-form-item :label="$t('reportSetting.DefaultType')" v-bind="formItemLayout">
                    <a-select
                           show-search
                            optionFilterProp="label"
                            allowClear
                            style="width: 100%"
                            size="small"
                            :placeholder="$t('publicLang.PleaseSelect')"
                            v-decorator="['defaultType',{ initialValue: importConfig.editVal.defaultType}]">
                        <a-select-option v-for="item in importConfig.selectData.defaultType" :value="item.DATA_KEY"  :key="item.DATA_KEY"  :label="item.DATA_VALUE" >{{item.DATA_VALUE}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item :label="$t('generic.defaultValue')" v-bind="formItemLayout">
                    <a-input
                        size="small"
                        style="width: 100%"
                        :placeholder="$t('publicLang.PleaseEnter')"
                        v-decorator="[
                      'defaultVal',
                      { initialValue: importConfig.editVal.defaultVal}
                     ]"/>
                </a-form-item>
                <a-form-item :label="$t('reportSetting.DataType')" v-bind="formItemLayout">
                    <a-select
                            show-search
                            allowClear
                            style="width: 100%"
                            size="small"
                            :placeholder="$t('publicLang.PleaseSelect')"
                            @change="decimalShowPlace"
                            v-decorator="['dataType',{ initialValue: importConfig.editVal.dataType == null ? 'Text': importConfig.editVal.dataType}]">
                        <a-select-option value="Text">Text</a-select-option>
                        <a-select-option value="Integer">Integer</a-select-option>
                        <a-select-option value="Decimal">Decimal</a-select-option>
                         <a-select-option value="Date">Date</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item :label="$t('reportSetting.Datalength')" v-bind="formItemLayout">
                    <a-input-number
                            size="small"
                            style="width: 100%"
                            :placeholder="$t('publicLang.PleaseEnter')"
                            v-decorator="[
                          'dataLength',
                          { initialValue: importConfig.editVal.dataLength == null ? 20 :  importConfig.editVal.dataLength}
                        ]"/>
                </a-form-item>
                                  <!-- @search="handleSearch"
                         @change="handleChange" -->
                <a-form-item :label="$t('reportSetting.DateTimeFormat')"   v-bind="formItemLayout" v-if="isShowDateFormat">
                    <a-select
                        allowClear
                        :placeholder="$t('publicLang.PleaseSelect')"
                        style="width: 100%"
                        size="small"      
                        v-decorator="[
                          'dateTimeFormat',
                          { initialValue: importConfig.editVal.dateTimeFormat } ]">
                        <a-select-option value="yyyy/MM/dd">yyyy/MM/dd</a-select-option>
                        <a-select-option value="yyyy-MM-dd">yyyy-MM-dd</a-select-option>
                        <a-select-option value="yyyyMMdd">yyyyMMdd</a-select-option>
                        <a-select-option value="dd/MM/yyyy">dd/MM/yyyy</a-select-option>
                        <a-select-option value="dd-MM-yyyy">dd-MM-yyyy</a-select-option>
                        <a-select-option value="dd-MMM-yyyy">dd-MMM-yyyy</a-select-option>
                        <a-select-option value="yyyy-MM">yyyy-MM</a-select-option>
                        <a-select-option value="yy-MM-dd">yy-MM-dd</a-select-option>

                        <a-select-option value="yyyy-dd-MM">yyyy-dd-MM</a-select-option>
                         <a-select-option value="yy-dd-MM">yy-dd-MM</a-select-option>
                         <a-select-option value="yy-MM">yy-MM</a-select-option>
                        <a-select-option value="dd-MM-yyyy">dd-MM-yyyy</a-select-option>
                        <a-select-option value="dd-MM-yy">dd-MM-yy</a-select-option>
                    </a-select>          
                </a-form-item>


       <a-form-item :label="$t('reportSetting.DecimalalPlace')" v-bind="formItemLayout" v-if="isShowdecimalPlace">
                    <a-select
                            allowClear
                            style="width: 100%"
                            size="small"
                            :placeholder="$t('publicLang.PleaseSelect')"
                            v-decorator="['fieldLengthDigit',{ initialValue: importConfig.editVal.fieldLengthDigit}]">
                        <a-select-option value="1">1</a-select-option>
                        <a-select-option value="2">2</a-select-option>
                        <a-select-option value="3">3</a-select-option>
                        <a-select-option value="4">4</a-select-option>
                        <a-select-option value="5">5</a-select-option>
                    </a-select>
                </a-form-item>


                
                <a-form-item :label="$t('reportSetting.StartPosition')" v-bind="formItemLayout">

                     <a-input-number
                            size="small"
                            style="width: 100%"
                            :placeholder="$t('publicLang.PleaseEnter')"
                            v-decorator="[
                          'startPosition',
                          { initialValue: importConfig.editVal.startPosition == null ? null :  importConfig.editVal.startPosition}
                        ]"/>
                </a-form-item>


                    <a-form-item :label="$t('reportSetting.EndPosition')" v-bind="formItemLayout">
                          <a-input-number
                            size="small"
                            style="width: 100%"
                            :placeholder="$t('publicLang.PleaseEnter')"
                            v-decorator="[
                          'endPosition',
                          { initialValue: importConfig.editVal.endPosition == null ? null :  importConfig.editVal.endPosition}
                        ]"/>
                </a-form-item>


                    
                    <a-form-item :label="$t('reportSetting.ReferenceKey')" v-bind="formItemLayout">
                          <a-input
                            size="small"
                            style="width: 100%"
                            :placeholder="$t('publicLang.PleaseEnter')"
                            v-decorator="[
                          'referenceKey',
                          { initialValue: importConfig.editVal.referenceKey == null ? null :  importConfig.editVal.referenceKey}
                        ]"/>
                </a-form-item>

              
                 <a-form-item :label="$t('reportSetting.RangeValue')" v-bind="formItemLayout">
                          <a-input
                            size="small"
                            style="width: 100%"
                            :placeholder="$t('publicLang.PleaseEnter')"
                            v-decorator="[
                          'rangeValue',
                          { initialValue: importConfig.editVal.rangeValue == null ? null :  importConfig.editVal.rangeValue}
                        ]"/>
                </a-form-item>



            </a-form>
        </a-modal>
        <!--Default Value 新增编辑-->
        <a-modal
                :maskClosable="false"
                :title="$t('generic.defaultValue')"
                :visible="defaultValueObj.defaultValueAddEditVis"
                width="50%"
                @cancel="() => (defaultValueObj.defaultValueAddEditVis = !defaultValueObj.defaultValueAddEditVis)">
            <template slot="footer">
                <a-button type="primary" size="small" @click="defalutValueSave">Save</a-button>
            </template>
            <a-modal
                    :maskClosable="false"
                    :title="$t('reportSetting.TableColumn')"
                    :visible="importConfig.MappingSearchVis"
                    width="50%"
                    @cancel="() => (importConfig.MappingSearchVis = !importConfig.MappingSearchVis)">
                <template slot="footer">
                    <a-button type="primary" size="small" @click="saveMappingVal">Save</a-button>
                </template>
                <a-tree-select
                        multiple
                        v-model="importConfig.mappingSearchValue"
                        tree-data-simple-mode
                        @change="treedataChange"
                        style="width: 100%"
                        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                        :tree-data="importConfig.treeData"
                        placeholder="Please select"
                        :load-data="onLoadData"
                />
            </a-modal>
            <a-form :form="defaultValueObj.defaultValueform" >
                <a-form-item :label="$t('reportSetting.Mapping')" v-bind="formItemLayout">
                    <div class="relative">
                        <a-input
                                size="small"
                                style="width: 100%"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                disabled
                                v-decorator="[
                              'toFieldName',
                              { initialValue: defaultValueObj.editVal.toFieldName}
                            ]"/>
                        <a-icon type="search" class="searIputIcon sbxs" @click="mappSearch('default')"/>
                    </div>
                </a-form-item>
                <a-form-item :label="$t('reportSetting.DefaultType')" v-bind="formItemLayout">
                    <a-select
                            show-search
                             optionFilterProp="label"
                            allowClear
                            style="width: 100%"
                            size="small"
                            :placeholder="$t('publicLang.PleaseSelect')"
                            v-decorator="['defaultType',{ initialValue: defaultValueObj.editVal.defaultType}]">
                        <a-select-option :key="item.DATA_KEY" v-for="item in defaultValueObj.selectData.defaultType" :value="item.DATA_KEY" :label="item.DATA_KEY">{{item.DATA_VALUE}}</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item :label="$t('reportSetting.Uniquekey')" v-bind="formItemLayout">
                    <a-switch v-decorator="['isUniqueKey',  { initialValue: defaultValueObj.editVal.isUniqueKey == 'Y' ? true: false,  valuePropName: 'checked'}]"/>
                </a-form-item>


                <a-form-item :label="$t('generic.DefaultValue')" v-bind="formItemLayout">
                    <a-input
                        size="small"
                        style="width: 100%"
                        :placeholder="$t('publicLang.PleaseEnter')"
                        v-decorator="[
                          'defaultVal',
                          { initialValue: defaultValueObj.editVal.defaultVal}
                        ]"/>
                </a-form-item>
                <a-form-item :label="$t('reportSetting.CombineFields')" v-bind="formItemLayout">
                    <div class="relative">
                        <a-input
                                size="small"
                                style="width: 100%"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                disabled
                                v-decorator="[
                              'combField',
                              { initialValue: defaultValueObj.editVal.combField}
                            ]"/>
                        <a-icon type="search" class="searIputIcon sbxs" @click="mappSearch('combine')"/>
                    </div>
                </a-form-item>


                <a-form-item :label="$t('reportSetting.Delimiter')"
                             v-show="defaultValueObj.editVal.combField || defaultValueObj.defaultValueform.combField"
                             v-bind="formItemLayout"  >
                    <a-input
                            size="small"
                            style="width: 100%"
                            :placeholder="$t('reportSetting.DelimiterDesc')"
                            v-decorator="[
                           'delimiter',
                           { initialValue: defaultValueObj.editVal.delimiter}
                         ]"/>
                </a-form-item>



     <a-form-item :label="$t('reportSetting.ReferenceKey')" v-bind="formItemLayout">
                          <a-input
                            size="small"
                            style="width: 100%"
                            :placeholder="$t('publicLang.PleaseEnter')"
                            v-decorator="[
                          'referenceKey',
                          { initialValue: defaultValueObj.editVal.referenceKey}
                        ]"/>
                </a-form-item>



     <a-form-item :label="$t('reportSetting.RangeValue')" v-bind="formItemLayout">
                          <a-input
                            size="small"
                            style="width: 100%"
                            :placeholder="$t('publicLang.PleaseEnter')"
                            v-decorator="[
                          'rangeValue',
                          { initialValue: defaultValueObj.editVal.rangeValue}
                        ]"/>
                </a-form-item>





            </a-form>
        </a-modal>

        <!--上传报错提示-->
        <a-modal v-model="upErrorInfo" :title="$t('publicLang.AlertMessage')" :footer="null" width="50%">
            <a-alert type="error">
                <div slot="description" style="height: 50vh;overflow-y: auto;">
                    <a-row v-for="(item,index) in upErrordata" class="infoError" :style="{background: index%2 ==0 ? '#efefef': '#fff',padding: '0 10px'}">
                        <span  >{{item}}</span>
                    </a-row>
                </div>
            </a-alert>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import axios from "axios";
    import cookie from "../../../api/cookie";
    export default{
        data(){
            return{
                ImportRuleSelectData: [], // add edit rule 下拉数据
                isColumnFilter: false, // Column Filter有值显示某些输入框
                upErrorInfo: false, // 报错弹窗
                upErrordata: [], // 报错信息
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 14 }
                    }
                },
                visible: false,
                ajaxdDeliimiter: null, // 请求后台返回的分割符
                selectModuleData: [], // left module 下拉数据
                ModuleVal: undefined, // 左边module 选中值
                LeftAddVis: false, // left 添加开关
                creatUid: null, // 添加之后后台返回uid upload 需要
                leftModeRadioVal: null, // left radio 当前选中
                radioDataLeft:[],// left radio 数据
                addform: this.$form.createForm(this),
                importConfigList: [], //  table  data
                defaultValueList: [], //  table  data
                leftEditTemplateVal: {}, // edit template 数据
                CloneTemplate:{
                    CloneTemplateVis: false, // 是否clone 开关
                    cloneform: this.$form.createForm(this), // clone 表单
                    projectSelectData:[], // project 下拉数据
                    rojectTemplateData: [], // projectTemplate  下拉数据
                },
                importConfig:{
                    importConfigAddEditVis: false, // 开关
                    importConfigform: this.$form.createForm(this), // import config 表单
                    selectData: {},// import config 下拉数据
                    editVal: {},// import config 当前编辑的数据
                    MappingSearchVis: false, // 去mappsearch
                    mappingSearchValue: undefined, //  mapping search value
                    treeData: [], // mappSearch 下拉数据
                },
                mappSearchType: null, // mapp search type
                isShowdecimalPlace: false, // 是否显示 DecimalalPlace
                isShowDateFormat : false, // 是否显示时间格式 
                defaultValueObj: {
                    defaultValueAddEditVis: false,
                    defaultValueform: this.$form.createForm(this),
                    selectData: {},
                    editVal: {}
                }
            }
        },
        filters: {
            radiosValueSubLength: function (val, params){
                if (val.length > 18) {
                    return val.substring(0, 18) + "...";
                } else {
                    return val;
                }
            }
        },
        methods: {
            handleSearch(val){
                if(val){
                    this.$nextTick(()=>{
                        this.importConfig.importConfigform.setFieldsValue({
                            fromFieldName: val
                        });
                    })
                }
            },
            ColumnFilterChange(val){
                if(val !=undefined){
                    this.isColumnFilter = true
                }else{
                    this.isColumnFilter = false
                }
            },
            treedataChange(data){
                for(let i in data){
                    if(data[i].indexOf('.') != -1){

                    }else{
                        data.splice(i,1)
                    }
                }
            },
//            uniqukey 为true idMandatory 默认选中
            uniqukeyChange(val){
                if(val){
                    this.importConfig.editVal.isMandatory = 'Y'
                }
            },
            show(type,id){
//                清空数据
                this.radioDataLeft = []
                this.importConfigList = []
                this.defaultValueList = []
                this.creatUid = null
                this.leftModeRadioVal = null
                this.visible = true
                this.ModuleVal = undefined
                if(type == 'edit'){
                    ajax.get(api.GENERICSUBMODULECODE,{geMapMasterUid:id}).then(res=>{
                        this.ModuleVal= res.data.moduleCode
                        this.leftModeRadioVal = res.data.geMapMasterUid
                        this.moduleCodeAjax()
                        this.leftRadioChange()
                    })
                }
                ajax.get(api.TEMPORTSUBMODULECODE).then(res => {
                    this.selectModuleData = res.data
                })
            },
//            顶部上传
            topFileChange(el){
                let params = this.leftModeRadioVal;
                let file = event.target.files[0]; // 获取上传excel
                ajax.post(api.GENERICIMPORTEXCELTEMPLATE, params, "chardimportExcel", file).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                        this.$refs.topimportExcelRef.value = ''
                        this.moduleCodeAjax()
                        this.leftRadioChange()

                    } else {
                        let data = res.msg
                        data = data.split('//')
                        data = Array.from(new Set(data))
                        this.upErrordata = data
                        this.upErrorInfo = true
                        this.$refs.topimportExcelRef.value = ''
                    }
                });
            },
            //            create 成功后才可以上传
            fileChange(el) {
                let params = this.creatUid;
                let file = event.target.files[0]; // 获取上传excel
                ajax.post(api.GENERICIMPORTEXCELCOLUMN, params, "chardimportExcel", file).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                        this.$refs.importExcelRef.value = ''
                        this.LeftAddVis = false
                    } else {
                        this.$customMessage.warning(res.msg, 5);
                        this.$refs.importExcelRef.value = ''
                    }
                });
            },
//            顶部下载
            topImportDown(){
                let ajaxurl = ajax.ajaxUrl();
                let that = this
                axios.get(ajaxurl + api.GENERICEXPORTEXCELTEMPLATE, {
                    params: {
                        geMasterUid: this.leftModeRadioVal,
                    },
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(function (data) {
                    if (!data) {
                        return;
                    }
                    let blob = new Blob([data.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                    });
                    let url = window.URL.createObjectURL(blob);
                    let aLink = document.createElement("a");
                    aLink.style.display = "none";
                    aLink.href = url;
                    aLink.setAttribute("download", "excel.xlsx");
                    document.body.appendChild(aLink);
                    aLink.click();
                    document.body.removeChild(aLink); //下载完成移除元素
                    window.URL.revokeObjectURL(url); //释放掉blob对象
                })
                    .catch(function (error) {
                        alert(error);
                    });
            },
//            表格数据
            initTable(id){
                ajax.get(api.GENERICGEMAPDETAIL, {geMasterUid: id}).then(res => {
                    this.ajaxdDeliimiter = res.data.deliimiter
                    this.defaultValueList = res.data.defaultValueList
                    this.importConfigList = res.data.importConfigList
                    let numberArr = this.importConfigList
//                    数据过滤
                    for (let i=0, len=numberArr.length; i<len; i++) {
                        for (let j=i+1; j<len; j++) {
                            if (numberArr[i].fromFieldName == numberArr[j].fromFieldName) {
                                let ai = numberArr[i]
                                let di = numberArr[j]
                                let a = ai.isUniqueKey + '-' + ai.defaultType + '-' + ai.defaultVal + '-' + ai.dataType + '-' + ai.dataLength + '-' + ai.fieldLengthDigit + '-' + ai.isMandatory +'-' + ai.referenceKey+'-'+ai.startPosition+'-'+ai.endPosition+'-'+ai.rangeValue
                                let b = di.isUniqueKey + '-' + di.defaultType + '-' + di.defaultVal + '-' + di.dataType + '-' + di.dataLength + '-' + di.fieldLengthDigit + '-' + di.isMandatory +'-' + di.referenceKey+'-'+di.startPosition+'-'+di.endPosition+'-'+ai.rangeValue
                                console.info(a )
                              if (a == b) {
                                  ai.toFieldName = ai.toFieldName + res.data.deliimiter + di.toFieldName
                                  ai.uid = ai.uid + ',' + di.uid
                                  numberArr.splice(j, 1);
                                  len--;
                                  j--;
                              }
                            }
                        }
                    }
                    this.importConfigList = numberArr
                })
            },
//            left start
            leftAddImport(type){
                this.creatUid = null
                if (this.ModuleVal) {
                    this.LeftAddVis = true
                    this.addform.resetFields();
                    this.leftEditTemplateVal = {}
                }
                ajax.get(api.GENERICGEMAPMASTEROPERATIONRULE,{moduleCode:this.ModuleVal}).then(res=>{
                    this.ImportRuleSelectData = res.data
                })

                if(type == 'edit'){
                    if(this.leftModeRadioVal == null){
                        this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'));
                        return
                    }
                    for(let i in this.radioDataLeft){
                        if(this.radioDataLeft[i].uid == this.leftModeRadioVal){
                            this.leftEditTemplateVal = this.radioDataLeft[i]
                            this.creatUid = this.leftEditTemplateVal.uid
                        }

                    }
                }

            },
//            create 添加
            CreateTemplate(){
                this.addform.validateFields((err, values) => {
                    if (!err) {
                        values.moduleCode = this.ModuleVal
                        if(this.leftEditTemplateVal.uid){
                            values.uid = this.leftEditTemplateVal.uid
                        }
                        ajax.post(api.GENERICGEMAPMASTER, values).then(res => {
                            if (res.code == 200) {
                                this.creatUid = res.data.uid
                                this.$message.success(res.msg);
                                this.moduleCodeAjax()
                            }
                        })
                    }
                });
            },

//            moducode change radio 数据
            moduleCodeAjax(){
                ajax.get(api.GENERICGEMAPMASTER, {moduleCode: this.ModuleVal}).then(res => {
                    this.radioDataLeft = res.data.geMapMasterList
                })
            },
//            left 删除
            leftDeleteImport(){
                if (!this.leftModeRadioVal) {
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
                    return
                }
                ajax.post(api.GENERICDELETEGEMAPMASTER, {"uids": [this.leftModeRadioVal]}).then(res => {
                    this.moduleCodeAjax()
                })
            },
//            left radio change 事件 请求table 数据
            leftRadioChange(){
                this.initTable(this.leftModeRadioVal)
            },
//            出发clone
            goClone(){
                this.CloneTemplate.CloneTemplateVis = true
                this.CloneTemplate.cloneform.resetFields();
                ajax.get(api.GENERICGEMAPMASTERPROJECTCODE).then(res => {
                    this.CloneTemplate.projectSelectData = res.data
                })
            },
//            project change 请求template
            ProjectChange(val){
                this.CloneTemplate.cloneform.setFieldsValue({['geMasterUid']: undefined})
                if (val) {
                    ajax.get(api.GENERICGEMAPMASTERTEMPLATE, {projectCode: val}).then(res => {
                        this.CloneTemplate.rojectTemplateData = res.data

                    })
                }

            },
            // withHdrChange(val){
            //     if (val) {
            //         this.leftEditTemplateVal.startRow = 2;
            //     } else {
            //         this.leftEditTemplateVal.startRow = 1;
            //     }
            // },
            createClone(){
                this.CloneTemplate.cloneform.validateFields((err, values) => {
                    if (!err) {
                        ajax.post(api.GENERICCLONEGEMAPMASTER, values).then(res => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.CloneTemplate.CloneTemplateVis = false
                                this.moduleCodeAjax()
                            }
                        })
                    }
                })
            },
            //   end left
//            right
//             table import config 删除
            tableDeleteImport(type){
                let arr = []
                if (type == 't') {
                    arr = this.$refs.ImportConfigRef.getCheckboxRecords()
                } else {
                    arr = this.$refs.defaultValueTableRef.getCheckboxRecords()
                }
                if (arr.length > 0) {
                    let uids = []
                    for (let i in arr) {
                        uids.push(arr[i].uid + '')
                    }
                    ajax.post(api.GENERICDELETEGEMAPDETAIL, {uids: uids}).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.msg);
                            this.initTable(this.leftModeRadioVal)
                        }
                    })
                }
            },
//            importConfig 添加编辑
            dbcellClickEvent({row}){
                this.addEditImportConfig('edit', row)
            },
            addEditImportConfig(type, row ={}){
                ajax.get(api.GENERICEXCELCOLUMN,{geMapMasterUid: this.leftModeRadioVal}).then(res=>{
                    this.importConfig.selectData = res.data
                })
                this.importConfig.importConfigAddEditVis = true
                this.importConfig.importConfigform.resetFields();
                if(type =='add'){
                     this.isShowDateFormat = false; 
                      this.isShowdecimalPlace = false
                    this.importConfig.editVal = {}
                }else{
                    this.importConfig.editVal = row

                    if(this.importConfig.editVal.dataType == 'Decimal'){
                        this.isShowdecimalPlace = true
                    }else{
                        this.isShowdecimalPlace = false
                    }

                    if(this.importConfig.editVal.dataType == 'Date'){
                        this.isShowDateFormat = true; 
                    }else{
                        this.isShowDateFormat = false; 
                    }

                }
            },
//            change Decimal 显示DecimalalPlace 输出框
            decimalShowPlace(val){
                if(val == 'Decimal'){
                    this.isShowdecimalPlace = true
                }else{
                    this.isShowdecimalPlace = false
                }

               if(val == 'Date'){
                        this.isShowDateFormat = true; 
                    }else{
                        this.isShowDateFormat = false; 
                    }

            },
//            save
            ImportConfigSave(){
                this.importConfig.importConfigform.validateFields((err, values)=>{
                    if (!err){
                        if(this.importConfig.editVal.uid != undefined){
                            values.uid = this.importConfig.editVal.uid
                        }
                        values.geMapMasterUid = this.leftModeRadioVal
                        values.isDefaultCol = false
                        values.isUniqueKey =  values.isUniqueKey ? 'Y' : 'N'
                        values.isMandatory =  values.isMandatory ? 'Y' : 'N'
                        ajax.post(api.GENERICGEMAPDETAIL,values).then(res=>{
                            if(res.code == 200){
                                this.$message.success(res.msg);
                                this.leftRadioChange()
                                this.importConfig.importConfigAddEditVis = false
                            }else{
                                this.$customMessage.warning(res.msg);
                            }
                        })
                    }
                })
            },
//            import config end

//            default value
//            编辑
            defaultValuedbcellClick({row}){
                this.defalutValAddEdit('edit', row)
            },
//            新增
            defalutValAddEdit(type,row = {}){
                ajax.get(api.GENERICEXCELCOLUMN,{geMapMasterUid: this.leftModeRadioVal}).then(res=>{
                    this.defaultValueObj.selectData = res.data
                })
                this.defaultValueObj.defaultValueAddEditVis = true
                this.defaultValueObj.defaultValueform.resetFields();
                if(type =='add'){
                    this.defaultValueObj.editVal = {}
                }else{
                    this.defaultValueObj.editVal = row
                }
            },
//            save
            defalutValueSave(){
                this.defaultValueObj.defaultValueform.validateFields((err, values)=>{
                    if (!err){
                        if(this.defaultValueObj.editVal.uid != undefined){
                            values.uid = this.defaultValueObj.editVal.uid
                        }
                        values.isUniqueKey =  values.isUniqueKey ? 'Y' : 'N'
                        values.geMapMasterUid = this.leftModeRadioVal
                        values.isDefaultCol = true
                        ajax.post(api.GENERICGEMAPDETAIL,values).then(res=>{
                            if(res.code == 200){
                                this.$message.success(res.msg);
                                this.leftRadioChange()
                                this.defaultValueObj.defaultValueAddEditVis = false
                            }else{
                                this.$customMessage.warning(res.msg);
                            }
                        })
                    }
                })
            },

            //            mapping search
            mappSearch(type){
                this.mappSearchType = type
                this.importConfig.MappingSearchVis = true
                this.importConfig.treeData =[]
                this.importConfig.mappingSearchValue = undefined
                ajax.get(api.GENERICGEMAPMASTERTABLEMANE,{geMapMasterUid: this.leftModeRadioVal}).then(res=>{
                    for(let i in res.data){
                        res.data[i].id = Number(i) + 1
                        res.data[i].pId = 0
                        res.data[i].isLeaf = false
                    }
                    this.importConfig.treeData = res.data
                })
            },
            onLoadData(treeNode){
                return new Promise(resolve => {
                    const obj = treeNode.dataRef;
                    if(this.mappSearchType == 'combine'){
                        ajax.get(api.GENERICGEMAPMASTERCOMBINEFIELDNAME,{moduleCode:obj.title,geMapMasterUid: this.leftModeRadioVal}).then(res=>{
                            if(res.data.length > 0){
                                for(let i in res.data){
                                    res.data[i].pId = obj.id
                                    res.data[i].isLeaf = true
                                    res.data[i].value = obj.value + '.' +  res.data[i].value
                                    res.data[i].title = obj.title + '.' +  res.data[i].title
                                }
                            }
                            this.importConfig.treeData = this.importConfig.treeData.concat(res.data)
//                            过滤重复数据 点击两二次回默认齿形一次 素以过滤相同数据
                            this.importConfig.treeData = this.reduceQuchong(this.importConfig.treeData)
                            resolve();
                        })
                    }else{
                        ajax.get(api.GENERICGEMAPMASTERFIELDNAME,{moduleCode:obj.title,geMapMasterUid: this.leftModeRadioVal}).then(res=>{
                            if(res.data.length > 0){
                                for(let i in res.data){
                                    res.data[i].pId = obj.id
                                    res.data[i].isLeaf = true
                                    res.data[i].value = obj.value + '.' +  res.data[i].value
                                    res.data[i].title = obj.title + '.' +  res.data[i].title
                                }
                            }
                            this.importConfig.treeData = this.importConfig.treeData.concat(res.data)
                            this.importConfig.treeData = this.reduceQuchong(this.importConfig.treeData)
                            resolve();
                        })
                    }

                });
            },
            reduceQuchong(data){
                let hash = {}
               return data.reduce((preVal, curVal) => {
                    hash[curVal.value] ? '' : hash[curVal.value] = true && preVal.push(curVal);
                    return preVal
                }, [])
            },
            saveMappingVal(){
                if(this.mappSearchType =='import'){
                    this.importConfig.editVal.toFieldName = this.importConfig.mappingSearchValue != undefined ? this.importConfig.mappingSearchValue.join(this.ajaxdDeliimiter): ''
                }else if(this.mappSearchType == 'default'){
                    this.defaultValueObj.editVal.toFieldName = this.importConfig.mappingSearchValue != undefined ? this.importConfig.mappingSearchValue.join(this.ajaxdDeliimiter): ''
                }else if(this.mappSearchType == 'combine'){
                    this.defaultValueObj.editVal.combField = this.importConfig.mappingSearchValue != undefined ? this.importConfig.mappingSearchValue.join(this.ajaxdDeliimiter): ''
                }else if( this.mappSearchType == 'defaultMapping'){
                    this.importConfig.editVal.defaultMapping = this.importConfig.mappingSearchValue != undefined ? this.importConfig.mappingSearchValue.join(this.ajaxdDeliimiter): ''
                }
                this.importConfig.MappingSearchVis = false
            },
         }
        }
</script>
<style lang="less">
    .importCon{
        border:1px solid #aaa;
        .importConTitle{
            height: 20px;
            line-height: 20px;
            padding-left:4px;
            border-bottom:1px solid #aaa;
            background: #a09b9b;
            font-weight: 600;
            font-size: 16px;
            margin: 0;
        }
        .ant-checkbox-group-item{
            display: block;
        }
        .importCheckboxGrop{
            height: 60vh;
            overflow-y: auto;
        }
    }
</style>